import React from 'react';

export const RoutesList = ({ routes }: { routes: any[] }) => (
	<React.Fragment>
		{routes.map((routeData: any) => (
			<div key={routeData.title}>
				<h3 className="text-2xl mt-10">{routeData.title}</h3>
				<div className="mb-2">
					<div>{routeData.text}</div>
					{routeData.paging && (
						<React.Fragment>
							- Pagination query params available.<br />
						</React.Fragment>
					)}
					{routeData.created && (
						<React.Fragment>
							- Created query params available.<br />
						</React.Fragment>
					)}
					{routeData.body && (
						<React.Fragment>
							<b>Body: </b>{routeData.body}
						</React.Fragment>
					)}
				</div>
				<div className="flex items-center justify-between font-mono">
					<div className="flex items-center">
						<div className="border px-2 rounded font-bold bg-blue-800 text-white">
							{routeData.type}
						</div>
						<div className="ml-4 text-xl">
							{routeData.path}
						</div>
					</div>
					<div className="ml-4">
						<b>Response:</b> {routeData.response}
					</div>
				</div>
			</div>
		))}
	</React.Fragment>
);